import React, { useEffect, useState, useContext } from "react";
import QRCode from "qrcode.react";
import toastError from "../../errors/toastError";
import { makeStyles } from "@material-ui/core/styles";
import {
  Dialog,
  DialogContent,
  Paper,
  Typography,
  CircularProgress,
  Box,
} from "@material-ui/core";
import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import { AuthContext } from "../../context/Auth/AuthContext";

const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    borderRadius: 16,
    padding: theme.spacing(4),
    maxWidth: 500,
    textAlign: "center",
  },
  qrContainer: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(2),
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: 300,
  },
  title: {
    fontWeight: "bold",
    fontSize: "1.4rem",
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(1),
  },
  instruction: {
    fontSize: "0.95rem",
    color: "#555",
    marginTop: theme.spacing(1),
  },
}));

const QrcodeModal = ({ open, onClose, whatsAppId }) => {
  const classes = useStyles();
  const [qrCode, setQrCode] = useState("");
  const { user, socket } = useContext(AuthContext);

  useEffect(() => {
    const fetchSession = async () => {
      if (!whatsAppId) return;

      try {
        const { data } = await api.get(`/whatsapp/${whatsAppId}`);
        setQrCode(data.qrcode);
      } catch (err) {
        toastError(err);
      }
    };
    fetchSession();
  }, [whatsAppId]);

  useEffect(() => {
    if (!whatsAppId) return;
    const companyId = user.companyId;

    const onWhatsappData = (data) => {
      if (data.action === "update" && data.session.id === whatsAppId) {
        setQrCode(data.session.qrcode);
      }

      if (
        data.action === "update" &&
        data.session.id === whatsAppId &&
        data.session.status === "CONNECTED"
      ) {
        onClose();
      }
    };

    socket.on(`company-${companyId}-whatsappSession`, onWhatsappData);

    return () => {
      socket.off(`company-${companyId}-whatsappSession`, onWhatsappData);
    };
  }, [whatsAppId, onClose]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{ className: classes.dialogPaper }}
    >
      <DialogContent>
        <Typography className={classes.title}>
          Abra o seu WhatsApp e escaneie o QR Code
        </Typography>

        <Box className={classes.qrContainer}>
          {qrCode ? (
            String(qrCode).startsWith("data:image") ? (
              <img
                src={qrCode}
                alt="QR Code WhatsApp"
                style={{
                  width: 280,
                  height: 280,
                  objectFit: "contain",
                  backgroundColor: "white",
                  padding: "10px",
                  borderRadius: "8px",
                }}
              />
            ) : (
              <QRCode
                value={qrCode}
                size={280}
                style={{
                  backgroundColor: "white",
                  padding: "10px",
                  borderRadius: "8px",
                }}
              />
            )
          ) : (
            <CircularProgress color="primary" />
          )}
        </Box>

        <Typography className={classes.instruction}>
          O QR Code possui um tempo limite para escaneamento. Caso expire ou ocorra um erro, feche este modal, atualize a página e clique no botão <strong>“Novo QR Code”</strong> para gerar um novo.
        </Typography>
      </DialogContent>
    </Dialog>
  );
};

export default React.memo(QrcodeModal);
